import * as angular from 'angular';
import {IQService} from "angular";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {TagsRequests} from "./tags-requests.service";
import {TagModel} from "../angular/models/tag.model";
import {TagsAlertsService} from "./tags-alerts.service";
import {TagType} from "../angular/types/tag.type";

export class TagsService {

  constructor(private tagsRequests: TagsRequests, private $q: IQService, private bringozLoaderService: BringozLoaderService,
              private tagsAlertsService: TagsAlertsService) {
  }

  getAllByTypes(types) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.tagsRequests.getAllByTypes(types)
      .then((tags) => {
        deferred.resolve(tags)
      })
      .catch((error) => {
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  createTag(tag: TagModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.tagsRequests.createTag(tag)
      .then((tag) => {
        this.tagsAlertsService.createTagSuccess();
        deferred.resolve(tag);
      })
      .catch((error) => {
        if (error.code === 400204) {
          this.tagsAlertsService.createTagError(error);
        } else {
          this.tagsAlertsService.createTagError();
        }
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  editTag(tag: TagModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.tagsRequests.editTag(tag)
      .then((tag) => {
        this.tagsAlertsService.editTagSuccess();
        deferred.resolve(tag)
      })
      .catch((error) => {
        this.tagsAlertsService.editTagError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  deleteTag(tag: TagModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.tagsRequests.editTag(tag)
      .then((tag) => {
        this.tagsAlertsService.deleteTagSuccess();
        deferred.resolve(tag)
      })
      .catch((error) => {
        this.tagsAlertsService.deleteTagError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }


  getTagsByName(names: string[], type: TagType) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.tagsRequests.getTagsByName(names, type)
      .then((tag) => {
        deferred.resolve(tag)
      })
      .catch((error) => {
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

}

angular
  .module('bringoz.admin.tags')
  .service('tagsService', TagsService);
